export default __webpack_public_path__ + "static/media/step1.11dd7b08.webp";